import {useParams} from "react-router-dom";
import {useQuery} from "react-query";
import {fetchContest, fetchPredictionResponses} from "../../api/api";
import {Alert, Card, Stack, Table} from "react-bootstrap";
import React, {useMemo} from "react";
import {LoadingSpinner} from "./ContestPage";
import {getPredictionColor} from "../../util/colors";
import {expectedResolutionDateMessage} from "./PredictionCard";
import {Page} from "../../common/Page";

export const PredictionsDetailsPage = () => {
  const contestId = useParams().contestId || '';
  const predictionOrdinal = parseInt(useParams().predictionOrdinal || '0');

  const {data: contest, isLoading: contestIsLoading, error: contestError} = useQuery(["contests", contestId],
    (_context) => fetchContest({id: contestId}),
    {
      enabled: !!contestId,
      retry: false
    })

  const {
    data: responses,
    isLoading: responsesLoading,
    error: responsesError
  } = useQuery(["contests", contestId, "predictions", predictionOrdinal, "responses"],
    (_context) => fetchPredictionResponses({contestId, predictionOrdinal}),
    {
      enabled: !!contestId && !!predictionOrdinal,
      retry: false
    })

  const prediction = useMemo(() => contest?.predictions?.find(p => p.ordinal === predictionOrdinal), [contest, predictionOrdinal])

  // TODO: build on this component for holding non-loaded state
  if (!contest || !prediction || !responses) {
    if (contestIsLoading || responsesLoading) {
      return <LoadingSpinner/>
    }
    if (contestError || responsesError) {
      return <Alert variant="danger">Error occurred</Alert>
    }
    return null;
  }

  return <Page title={prediction?.text}
               breadcrumbs={{
                 title: `Prediction ${predictionOrdinal}`,
                 parents: [{
                   title: "Home",
                   link: "/"
                 },
                   {
                     title: contest?.name,
                     link: `/predictions/contests/${contestId}`
                   }
                 ]
               }}>
    <p>{prediction.details}</p>
    <Card>
      <Card.Header>Result</Card.Header>
      <Card.Body>
        <Stack direction={"horizontal"} gap={3} className={"justify-content-between"}>
          {prediction.outcome ?
            <span>Result: <span style={{fontWeight: 'bold'}}>{prediction.outcome.toUpperCase()}</span></span> :
            <span
              className={"text-muted"}>{expectedResolutionDateMessage(prediction.expectedResolution)}</span>}
          <span>Your prediction: <span style={{fontWeight: 'bold'}}>{prediction.value}%</span></span>
          <span>
                Points:{' '}
            {(prediction.outcome && prediction.score) ?
              <span style={{color: getPredictionColor(prediction.value, prediction.outcome), fontWeight: 'bold'}}>
                  {prediction.score}
                </span>
              : '–'}
              </span>
        </Stack>
        {prediction.outcomeText && <div className={"mt-3"}>{prediction.outcomeText}</div>}
      </Card.Body>
    </Card>
    <h2 className={"mt-5"}>Full results</h2>
    <Table>
      <thead>
      <tr>
        <th>Name</th>
        <th>Prediction</th>
        <th>Points</th>
      </tr>
      </thead>
      <tbody>
      {responses.responses.map((response, index) => <tr key={index}>
        <td>{response.participantName}</td>
        <td>{response.value}%</td>
        <td>{response.score ? response.score : "–"}</td>
      </tr>)}
      </tbody>
    </Table>
  </Page>
}